
import { toast } from "sonner";
import { SlackIntegration } from "../../types";

/**
 * Hook that provides handlers for Slack integration settings
 */
export const useSettingsHandlers = () => {
  const handleTagChange = (
    value: string, 
    setTriggerTag: (value: string) => void,
    updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>
  ) => {
    setTriggerTag(value);
    
    if (updateSettings) {
      updateSettingsWithFeedback(
        { trigger_tag: value },
        updateSettings
      );
    }
  };
  
  const handleFileProcessingChange = (
    checked: boolean, 
    setIsFileProcessingEnabled: (checked: boolean) => void,
    updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>
  ) => {
    setIsFileProcessingEnabled(checked);
    
    if (updateSettings) {
      updateSettingsWithFeedback(
        { is_file_processing_enabled: checked },
        updateSettings
      );
    }
  };
  
  const handleAutoResponsesChange = (
    checked: boolean, 
    setIsAutoResponsesEnabled: (checked: boolean) => void,
    updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>
  ) => {
    setIsAutoResponsesEnabled(checked);
    
    if (updateSettings) {
      updateSettingsWithFeedback(
        { is_auto_responses_enabled: checked },
        updateSettings
      );
    }
  };
  
  const handleRoleDetectionChange = (
    checked: boolean, 
    setIsRoleDetectionEnabled: (checked: boolean) => void,
    _updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>
  ) => {
    // Just update the UI state since role detection is always enabled
    setIsRoleDetectionEnabled(checked);
  };
  
  const updateSettingsWithFeedback = async (
    settings: Partial<SlackIntegration>, 
    saveSettings: (settings: Partial<SlackIntegration>) => Promise<void>
  ): Promise<void> => {
    try {
      await saveSettings(settings);
      toast.success("Settings updated successfully");
    } catch (error) {
      console.error("Error updating settings:", error);
      toast.error("Failed to update settings");
    }
  };
  
  return {
    handleTagChange,
    handleFileProcessingChange,
    handleAutoResponsesChange,
    handleRoleDetectionChange,
    updateSettingsWithFeedback
  };
};
